type NavigationItem = {
  name: string
  href: string
}

type NavigationItemWithChildren = NavigationItem & {
  children?: NavigationItem[]
}

export const navigation: NavigationItemWithChildren[] = [
  {
    name: 'Solutions',
    href: '/',
    children: [
      { name: 'Adaptation Planning', href: '/solutions/adaptation-planning' },
      { name: 'Asset & Infrastructure Planning', href: '/solutions/asset-infrastructure-planning' },
      { name: 'Land Use Planning & Development', href: '/solutions/land-use-planning' },
      { name: 'Emergency Planning & Business Continuity', href: '/solutions/emergency-planning' },
    ],
  },
  {
    name: 'Products',
    href: '/products',
    children: [{ name: 'Resilience Explorer® | Property', href: '/products/property' }],
  },
  { name: 'Urban Intelligence', href: '/team' },
  { name: "Let's Talk", href: '/contact' },
]
